(function () {

    "use strict";

    function manualesController(basicListService, manualesService) {

        var vm = basicListService.instantiate(this);

        vm.service = manualesService;
        vm.templateModalEdit = false;
        vm.stateForEdit = "manual";
        vm.showCreate = true;
        vm.configHead(breadcrumbItems());
        vm.getItemsPaged();

        function breadcrumbItems() {
            return [{
                text: "Inicio",
                action: vm.goHome
            }, {
                text: "Manuales",
                action: null
            }
            ];
        }
    }

    manualesController.$inject = ["sphforms.basicListService", "sphforms.manualesService"];

    angular.module("sphforms.formacion")
        .component("sphformsManuales", {
            controller: manualesController,
            templateUrl: "modules/formacion/components/manuales/manuales.template.html"
        });

}());
